/**
 * WarrantyRegistration - Handles warranty registration form submission to HulkApps FormBuilder
 */
class WarrantyRegistration {
  constructor(options = {}) {
    this.form = null;
    this.validationErrors = {};
    this.accumulatedFiles = {};
    
    // API Configuration for warranty form
    this.apiConfig = {
      uploadUrl: options.uploadUrl || 'https://formbuilder.hulkapps.com/forms/file_upload/2_hkLenGtncJKXg2C-GQ-A',
      submitUrl: options.submitUrl || 'https://formbuilder.hulkapps.com/forms/create_response/n-1TwLGT8jWnXYAlPs5HjA',
      accessToken: options.accessToken || '6003ad618bdb6a61'
    };
    
    this.init();
  }
  
  init() {
    this.form = document.querySelector('.warranty-form');
    if (!this.form) return;
    
    this.injectValidationStyles();
    this.populateStates();
    this.initFormValidation();
    this.initFormSubmission();
    this.initFileInputFeedback();
  }
  
  injectValidationStyles() {
    if (document.getElementById('warranty-validation-styles')) return;
    
    const styleSheet = document.createElement('style');
    styleSheet.id = 'warranty-validation-styles';
    styleSheet.textContent = `
      .warranty-form .is-invalid {
        border-color: #dc3545 !important;
        box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25) !important;
      }
      
      .warranty-form .field-error {
        display: block;
        width: 100%;
        margin-top: 0.25rem;
        font-size: 0.875em;
        color: #dc3545;
      }
      
      .warranty-form .form-message {
        border-radius: 0.375rem;
        padding: 0.75rem 1rem;
        margin-bottom: 1rem;
        border: 1px solid transparent;
      }
      
      .warranty-form .alert-danger {
        color: #721c24;
        background-color: #f8d7da;
        border-color: #f5c6cb;
      }
      
      .warranty-form .alert-success {
        color: #155724;
        background-color: #d4edda;
        border-color: #c3e6cb;
      }
      
      .warranty-form .proof-dropzone {
        position: relative;
        border-radius: 5px;
        min-height: 90px;
        display: flex;
        padding: 20px;
        align-items: center;
        justify-content: center;
        border: 1px dashed #A7A5A6;
        flex-direction: column;
        gap: 8px;
      }
      
      .warranty-form .proof-dropzone.has-file {
        border-color: #5BBA47;
        background-color: #f8fff8;
      }
      
      .warranty-form .proof-file {
        position: absolute;
        inset: 0;
        opacity: 0;
        cursor: pointer;
        z-index: 2;
      }
      
      .warranty-form .proof-file-btn {
        position: relative;
        z-index: 1;
        color: #656263;
        line-height: 1;
        font-size: 11px;
        cursor: pointer;
        padding: 9px 7px;
        border-radius: 4px;
        background: #F1F1F1;
        display: inline-block;
      }
      
      .warranty-form .file-selected-info {
        display: none;
        color: #5BBA47;
        font-size: 12px;
        font-weight: 500;
        text-align: center;
        word-break: break-word;
        max-width: 100%;
      }
      
      .warranty-form .proof-dropzone.has-file .file-selected-info {
        display: block;
      }
      
      .warranty-form .proof-dropzone.has-file .proof-file-btn {
        background: #5BBA47;
        color: white;
      }
      
      .warranty-form .file-remove-btn {
        display: none;
        background: #dc3545;
        color: white;
        border: none;
        padding: 4px 8px;
        border-radius: 3px;
        font-size: 11px;
        cursor: pointer;
        transition: background-color 0.2s;
        position: relative;
        z-index: 10;
      }
      
      .warranty-form .file-remove-btn:hover {
        background: #c82333;
      }
      
      .warranty-form .proof-dropzone.has-file .file-remove-btn {
        display: inline-block;
      }
    `;
    document.head.appendChild(styleSheet);
  }
  
  populateStates() {
    const stateSelect = document.getElementById('AddressState');
    if (!stateSelect) return;
    
    const usStates = [
      ['AL', 'Alabama'], ['AK', 'Alaska'], ['AZ', 'Arizona'], ['AR', 'Arkansas'],
      ['CA', 'California'], ['CO', 'Colorado'], ['CT', 'Connecticut'], ['DE', 'Delaware'],
      ['FL', 'Florida'], ['GA', 'Georgia'], ['HI', 'Hawaii'], ['ID', 'Idaho'],
      ['IL', 'Illinois'], ['IN', 'Indiana'], ['IA', 'Iowa'], ['KS', 'Kansas'],
      ['KY', 'Kentucky'], ['LA', 'Louisiana'], ['ME', 'Maine'], ['MD', 'Maryland'],
      ['MA', 'Massachusetts'], ['MI', 'Michigan'], ['MN', 'Minnesota'], ['MS', 'Mississippi'],
      ['MO', 'Missouri'], ['MT', 'Montana'], ['NE', 'Nebraska'], ['NV', 'Nevada'],
      ['NH', 'New Hampshire'], ['NJ', 'New Jersey'], ['NM', 'New Mexico'], ['NY', 'New York'],
      ['NC', 'North Carolina'], ['ND', 'North Dakota'], ['OH', 'Ohio'], ['OK', 'Oklahoma'],
      ['OR', 'Oregon'], ['PA', 'Pennsylvania'], ['RI', 'Rhode Island'], ['SC', 'South Carolina'],
      ['SD', 'South Dakota'], ['TN', 'Tennessee'], ['TX', 'Texas'], ['UT', 'Utah'],
      ['VT', 'Vermont'], ['VA', 'Virginia'], ['WA', 'Washington'], ['WV', 'West Virginia'],
      ['WI', 'Wisconsin'], ['WY', 'Wyoming'], ['DC', 'District of Columbia']
    ];
    
    // Clear existing options except the placeholder
    stateSelect.innerHTML = '<option value="" selected disabled>Select state</option>';
    
    usStates.forEach(function(state) {
      const option = document.createElement('option');
      option.value = state[0];
      option.textContent = state[1];
      stateSelect.appendChild(option);
    });
  }
  
  initFormValidation() {
    if (!this.form) return;
    
    const requiredFields = this.form.querySelectorAll('[required]');
    requiredFields.forEach(field => {
      if (field && typeof field.addEventListener === 'function') {
        field.addEventListener('blur', () => this.validateField(field));
        field.addEventListener('input', () => this.clearFieldError(field));
      }
    });
  }
  
  initFormSubmission() {
    if (!this.form) return;
    
    this.form.addEventListener('submit', (e) => {
      e.preventDefault();
      this.handleFormSubmission();
    });
    
    const submitButton = this.form.querySelector('button[type="submit"]');
    if (submitButton) {
      submitButton.addEventListener('click', (e) => {
        e.preventDefault();
        this.handleFormSubmission();
      });
    }
  }
  
  validateField(field) {
    const fieldValue = field.value.trim();
    const isRequired = field.hasAttribute('required');
    
    if (isRequired && !fieldValue) {
      this.showFieldError(field, 'This field is required.');
      return false;
    }
    
    if (fieldValue) {
      this.clearFieldError(field);
    }
    
    switch (field.type) {
      case 'email':
        return this.validateEmail(field);
      case 'tel':
        return this.validatePhone(field);
      case 'file':
        return this.validateFile(field);
      default:
        return true;
    }
  }
  
  validateEmail(field) {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (field.value && !emailPattern.test(field.value)) {
      this.showFieldError(field, 'Please enter a valid email address.');
      return false;
    }
    return true;
  }
  
  validatePhone(field) {
    const phoneValue = field.value.replace(/\D/g, '');
    if (field.value && (phoneValue.length < 10 || phoneValue.length > 15)) {
      this.showFieldError(field, 'Please enter a valid phone number.');
      return false;
    }
    return true;
  }
  
  validateFile(field) {
    if (field.hasAttribute('required') && field.files.length === 0) {
      this.showFieldError(field, 'Please select a file.');
      return false;
    }
    
    if (field.files.length > 0) {
      for (let i = 0; i < field.files.length; i++) {
        const file = field.files[i];
        if (this.isVideoFile(file)) {
          this.showFieldError(field, 'Video files are not allowed. Please select images or documents only.');
          return false;
        }
      }
    }
    
    return true;
  }
  
  isVideoFile(file) {
    if (file.type && file.type.startsWith('video/')) {
      return true;
    }
    
    const videoExtensions = ['.mp4', '.avi', '.mov', '.wmv', '.flv', '.webm', '.mkv', '.m4v', '.3gp', '.ogv'];
    const fileName = file.name.toLowerCase();
    return videoExtensions.some(ext => fileName.endsWith(ext));
  }
  
  showFieldError(field, message) {
    this.clearFieldError(field);
    
    const errorDiv = document.createElement('div');
    errorDiv.className = 'field-error text-danger small mt-1';
    errorDiv.textContent = message;
    errorDiv.setAttribute('data-field-error', field.id);
    
    field.parentNode.insertBefore(errorDiv, field.nextSibling);
    field.classList.add('is-invalid');
    this.validationErrors[field.id] = message;
  }
  
  clearFieldError(field) {
    const existingError = field.parentNode.querySelector(`[data-field-error="${field.id}"]`);
    if (existingError) {
      existingError.remove();
    }
    
    field.classList.remove('is-invalid');
    delete this.validationErrors[field.id];
  }
  
  validateAllFields() {
    let isValid = true;
    this.validationErrors = {};
    
    this.clearAllValidationStates();
    
    const requiredFields = this.form.querySelectorAll('[required]');
    requiredFields.forEach(field => {
      if (!this.validateField(field)) {
        isValid = false;
      }
    });
    
    return isValid;
  }
  
  clearAllValidationStates() {
    const allFields = this.form.querySelectorAll('input, select, textarea');
    allFields.forEach(field => {
      field.classList.remove('is-invalid');
      const existingError = field.parentNode.querySelector(`[data-field-error="${field.id}"]`);
      if (existingError) {
        existingError.remove();
      }
    });
  }
  
  handleFormSubmission() {
    const isValid = this.validateAllFields();
    
    if (!isValid) {
      const firstErrorField = this.form.querySelector('.is-invalid');
      if (firstErrorField) {
        firstErrorField.focus();
        firstErrorField.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      return false;
    }
    
    const formData = this.collectFormData();
    this.submitForm(formData);
    return false;
  }
  
  collectFormData() {
    if (!this.form) {
      throw new Error('Form element not found');
    }
    
    const formData = new FormData(this.form);
    const requestData = {};
    
    const fieldMapping = {
      'address[first_name]': 'First Name',
      'address[last_name]': 'Last Name',
      'customer[email]': 'Email',
      'address[phone]': 'Phone',
      'address[address1]': 'Street Address',
      'address[city]': 'City',
      'address[state]': 'State',
      'address[zip]': 'Zip Code',
      'address[country]': 'Country',
      'customer[model_name]': 'Model Name',
      'address[model_number]': 'Model Number',
      'address[date_purchased]': 'Date of Purchase',
      'customer[purchased_from]': 'Purchased From',
      'address[batch_code]': 'Batch Code',
      'address[plaque_id_number]': 'Plaque ID Number',
      'customer[box_one]': 'Box Number 1',
      'address[box_two]': 'Box Number 2',
      'address[box_three]': 'Box Number 3',
      'address[box_four]': 'Box Number 4',
      'address[default]': 'Newsletter Subscription',
      'proof_upload': 'Product Photo',
      'proof_purchase': 'Proof of Purchase',
      'proof_additional': 'Additional Photos'
    };
    
    for (let [key, value] of formData.entries()) {
      if (key.startsWith('proof_') || key === 'file_data') continue;
      
      const apiFieldName = fieldMapping[key] || key;
      
      if (value && value.toString().trim() !== '') {
        if (key === 'address[default]') {
          requestData[apiFieldName] = 'Yes';
        } else {
          requestData[apiFieldName] = value.toString().trim();
        }
      }
    }
    
    return requestData;
  }
  
  async uploadFile(formData, fileInputId) {
    const response = await fetch(this.apiConfig.uploadUrl, {
      method: "POST",
      headers: {
        "X-Form-Access-Token": this.apiConfig.accessToken
      },
      body: formData
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    return await response.json();
  }
  
  async uploadAllFiles() {
    const fileUploads = {};
    const fileInputs = [
      { id: 'warranty-proof-upload', name: 'Product Photo' },
      { id: 'warranty-proof-purchase', name: 'Proof of Purchase' },
      { id: 'warranty-additional-photos', name: 'Additional Photos', multiple: true }
    ];
    
    for (const fileInput of fileInputs) {
      const input = document.getElementById(fileInput.id);
      
      try {
        if (fileInput.multiple && this.accumulatedFiles[fileInput.id]) {
          const accumulatedFiles = this.accumulatedFiles[fileInput.id];
          const uploadedFiles = [];
          
          for (let i = 0; i < accumulatedFiles.length; i++) {
            const formData = new FormData();
            formData.append("file_data", accumulatedFiles[i]);
            
            const uploadResponse = await this.uploadFile(formData, `${fileInput.id}_${i}`);
            
            if (!uploadResponse.error && uploadResponse.response && uploadResponse.response.url) {
              uploadedFiles.push({
                url: uploadResponse.response.url,
                type: "file"
              });
            }
          }
          
          if (uploadedFiles.length > 0) {
            fileUploads[fileInput.name] = {
              type: "file",
              upload_type: "multiple",
              files: uploadedFiles
            };
          }
        } else if (input && input.files && input.files.length > 0) {
          const formData = new FormData();
          formData.append("file_data", input.files[0]);
          
          const uploadResponse = await this.uploadFile(formData, fileInput.id);
          
          if (!uploadResponse.error && uploadResponse.response && uploadResponse.response.url) {
            fileUploads[fileInput.name] = {
              type: "file",
              url: uploadResponse.response.url
            };
          }
        }
      } catch (error) {
        console.error(`Error uploading file ${fileInput.id}:`, error);
      }
    }
    
    return fileUploads;
  }
  
  async submitFormData(requestData) {
    const jsonData = JSON.stringify({ formResponse: requestData });
    
    const response = await fetch(this.apiConfig.submitUrl, {
      method: "POST",
      headers: {
        "X-Form-Access-Token": this.apiConfig.accessToken,
        "Content-Type": "application/json",
        "accept": "application/json"
      },
      body: jsonData
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    return await response.json();
  }
  
  async submitForm(formData) {
    try {
      this.showFormLoading(true);
      
      const fileUploads = await this.uploadAllFiles();
      const requestData = this.collectFormData();
      
      Object.assign(requestData, fileUploads);
      
      const result = await this.submitFormData(requestData);
      
      this.showFormLoading(false);
      this.showFormSuccess('Your warranty registration has been submitted successfully!');
      
      setTimeout(() => {
        this.form.reset();
        this.clearAllValidationStates();
        this.resetAllFileInputs();
      }, 2000);
      
    } catch (error) {
      this.showFormLoading(false);
      this.showFormError('Something went wrong while submitting your registration. Please try again.');
    }
  }
  
  showFormLoading(show) {
    const submitButton = this.form.querySelector('button[type="submit"]');
    if (!submitButton) return;
    
    if (show) {
      submitButton.disabled = true;
      submitButton.dataset.originalText = submitButton.textContent;
      submitButton.textContent = 'Submitting...';
    } else {
      submitButton.disabled = false;
      submitButton.textContent = submitButton.dataset.originalText || 'Submit';
    }
  }
  
  showFormError(message) {
    this.clearFormMessages();
    const messageDiv = this.createFormMessage(message, 'error');
    this.form.insertBefore(messageDiv, this.form.firstChild);
    messageDiv.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
  
  showFormSuccess(message) {
    this.clearFormMessages();
    const messageDiv = this.createFormMessage(message, 'success');
    this.form.insertBefore(messageDiv, this.form.firstChild);
    messageDiv.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
  
  createFormMessage(message, type) {
    const messageDiv = document.createElement('div');
    messageDiv.className = `form-message alert ${type === 'error' ? 'alert-danger' : 'alert-success'} mb-4`;
    messageDiv.textContent = message;
    return messageDiv;
  }
  
  clearFormMessages() {
    const existingMessages = this.form.querySelectorAll('.form-message');
    existingMessages.forEach(msg => msg.remove());
  }
  
  initFileInputFeedback() {
    if (!this.form) return;
    
    const fileInputs = this.form.querySelectorAll('input[type="file"]');
    fileInputs.forEach(input => {
      if (input && typeof input.addEventListener === 'function') {
        input.addEventListener('change', (event) => {
          this.handleFileSelection(event.target);
        });
      }
    });
    
    const removeButtons = this.form.querySelectorAll('.file-remove-btn');
    removeButtons.forEach(button => {
      if (button && typeof button.addEventListener === 'function') {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          const targetId = event.target.getAttribute('data-target');
          if (targetId) {
            this.handleFileRemoval(targetId);
          }
        });
      }
    });
    
    const addFileButtons = this.form.querySelectorAll('.proof-file-btn');
    addFileButtons.forEach(button => {
      if (button && typeof button.addEventListener === 'function') {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          const dropzone = button.closest('.proof-dropzone');
          if (dropzone) {
            const fileInput = dropzone.querySelector('input[type="file"]');
            if (fileInput && typeof fileInput.click === 'function') {
              fileInput.focus();
              fileInput.click();
            }
          }
        });
      }
    });
  }
  
  handleFileSelection(fileInput) {
    const dropzone = fileInput.closest('.proof-dropzone');
    const infoDiv = dropzone ? dropzone.querySelector('.file-selected-info') : null;
    
    if (!dropzone || !infoDiv) return;
    
    const files = fileInput.files;
    
    if (files && files.length > 0) {
      let hasVideoFile = false;
      for (let i = 0; i < files.length; i++) {
        if (this.isVideoFile(files[i])) {
          hasVideoFile = true;
          break;
        }
      }
      
      if (hasVideoFile) {
        fileInput.value = '';
        dropzone.classList.remove('has-file');
        infoDiv.innerHTML = '';
        this.showFieldError(fileInput, 'Video files are not allowed. Please select images or documents only.');
        return;
      }
      
      if (fileInput.hasAttribute('multiple')) {
        this.handleMultipleFileAccumulation(fileInput, files, dropzone, infoDiv);
      } else {
        dropzone.classList.add('has-file');
        this.clearFieldError(fileInput);
        
        const fileName = files[0].name;
        const fileSize = this.formatFileSize(files[0].size);
        infoDiv.innerHTML = `<strong>Selected:</strong><br>${fileName}<br><small>(${fileSize})</small>`;
      }
    } else {
      dropzone.classList.remove('has-file');
      infoDiv.innerHTML = '';
      if (fileInput.hasAttribute('multiple')) {
        delete this.accumulatedFiles[fileInput.id];
      }
    }
  }
  
  handleMultipleFileAccumulation(fileInput, newFiles, dropzone, infoDiv) {
    if (!this.accumulatedFiles[fileInput.id]) {
      this.accumulatedFiles[fileInput.id] = [];
    }
    
    const existingFiles = this.accumulatedFiles[fileInput.id];
    for (let i = 0; i < newFiles.length; i++) {
      const newFile = newFiles[i];
      const isDuplicate = existingFiles.some(existingFile => 
        existingFile.name === newFile.name && 
        existingFile.size === newFile.size && 
        existingFile.lastModified === newFile.lastModified
      );
      
      if (!isDuplicate) {
        existingFiles.push(newFile);
      }
    }
    
    const totalFiles = this.accumulatedFiles[fileInput.id].length;
    
    if (totalFiles > 0) {
      dropzone.classList.add('has-file');
      this.clearFieldError(fileInput);
      
      let fileList = '';
      this.accumulatedFiles[fileInput.id].forEach((file, index) => {
        const fileName = file.name;
        const fileSize = this.formatFileSize(file.size);
        fileList += `${index + 1}. ${fileName} <small>(${fileSize})</small><br>`;
      });
      
      infoDiv.innerHTML = `<strong>Selected ${totalFiles} files:</strong><br>${fileList}`;
    }
  }
  
  formatFileSize(bytes) {
    if (bytes === 0) return '0 Bytes';
    
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  }
  
  handleFileRemoval(fileInputId) {
    const fileInput = document.getElementById(fileInputId);
    if (!fileInput) return;
    
    const dropzone = fileInput.closest('.proof-dropzone');
    const infoDiv = dropzone ? dropzone.querySelector('.file-selected-info') : null;
    
    if (!dropzone || !infoDiv) return;
    
    fileInput.value = '';
    
    if (fileInput.hasAttribute('multiple')) {
      delete this.accumulatedFiles[fileInputId];
    }
    
    dropzone.classList.remove('has-file');
    infoDiv.innerHTML = '';
    this.clearFieldError(fileInput);
  }
  
  resetAllFileInputs() {
    const fileInputs = this.form.querySelectorAll('input[type="file"]');
    fileInputs.forEach(input => {
      this.handleFileRemoval(input.id);
    });
    this.accumulatedFiles = {};
  }
}

document.addEventListener('DOMContentLoaded', function() {
  try {
    new WarrantyRegistration();
  } catch (error) {
    console.error('Error initializing WarrantyRegistration:', error);
  }
});
